import { makeStyles } from 'tss-react/mui';

const LOGO_SIZE = 60;

const useStyles = makeStyles()(theme => ({
  toolbarRoot: {
    display: 'grid',
    gridTemplateColumns: `${LOGO_SIZE}px 1fr auto`,
    gridGap: theme.spacing(2),
  },
  searchIcon: {
    justifySelf: 'flex-end',
  },
  element: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridGap: theme.spacing(2),
  },
  elementRight: {
    justifyContent: 'flex-end',
  },
  serviceProvider: {
    display: 'grid',
    gridGap: theme.spacing(1),
    gridTemplateColumns: 'auto auto',
    alignItems: 'center',
    whiteSpace: 'pre-line',
  },
  logo: {
    maxWidth: `${LOGO_SIZE}px`,
    maxHeight: `${LOGO_SIZE - 16}px`,
  },
}));

export default useStyles;
